import * as React from "react";
import type { SVGProps } from "react";
const SvgBeachfrontIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.655 1.12a.56.56 0 0 0-.227.105l-10.08 7.28a.56.56 0 0 0 .28 1.015l6.16.56H11.2v10.08h1.12V10.08h3.413l6.16-.56a.56.56 0 0 0 .28-1.015l-10.08-7.28a.56.56 0 0 0-.438-.105m.105 1.82 3.01 6.02H8.75zm-1.522.525-2.73 5.46-4.27-.385zm3.062.017 6.982 5.058-4.27.385zm12.425 12.18a.6.6 0 0 0-.14.035.5.5 0 0 0-.14.053l-9.905 4.97H1.627a.56.56 0 0 0-.507.56v2.24c0 .308.252.56.56.56H2.8v2.24c0 .308.252.56.56.56H5.6c.308 0 .56-.252.56-.56v-2.24h15.68v2.24c0 .308.252.56.56.56h2.24c.308 0 .56-.252.56-.56v-2.24h1.12c.308 0 .56-.252.56-.56v-2.24a.56.56 0 0 0-.56-.56h-1.26l-.875-3.08 1.75-.875a.561.561 0 0 0-.21-1.103m-2.573 2.503.735 2.555H18.06zM2.24 21.84h23.52v1.12H2.24zm1.68 2.24h1.12v1.68H3.92zm19.04 0h1.12v1.68h-1.12z"
    />
  </svg>
);
export default SvgBeachfrontIcon;
